export default function(o, project){

  var projectLabel = o.util.getTranslation(o, 'project')
  var backLabel = o.util.getTranslation(o, 'back')

  var home = function(){
    history.pushState({}, '', '/')
    o.render(o)
  }

  var back = function(){
    history.go(-1)
  }

  var projectDiv =
    $('<div>')
    .css({
      display: 'inline-block',
      margin: '0.3rem',
      color: o.colors.red,
    })
    .html(
      `${projectLabel} ${project}`
    )

  var div =
    $('<div>')
    .css({
      textAlign: 'center',
      whiteSpace: 'nowrap',
      overflowY: 'auto',
      '-webkit-overflow-scrolling': 'touch',
      fontSize: o.fontSizeDef.s,
      padding: "0.8rem",
    })
    .append([

      o.component.button(o, 'open memory box', home),

      o.component.spacer(o),

      projectDiv,

      o.component.spacer(o),

      o.component.button(o, backLabel, back),

    ])

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/box/header/header.js